'use client';

import { useEffect } from 'react';
import { useParams, usePathname, useRouter } from 'next/navigation';
import { useSubscription } from '@apollo/client';
import { datadogLogs } from '@datadog/browser-logs';
import { DataDogCustomLog } from 'shared/types/logs/datadog';
import useGetUserInfo from 'helpers/hooks/useGetUserInfo';
import { deleteCognitoCookies } from 'helpers/padi/cognito';
import { SUBSCRIPTION_SLO_DELETE_SESSION } from 'helpers/padi/slo/gql';
import { useAccount } from 'frontastic';

const SloSubscribeOnDelete: React.FC = () => {
  const { userData } = useGetUserInfo();
  const sub = userData?.sub;
  const { account, logout } = useAccount();
  const pathname = usePathname();
  const router = useRouter();
  const { locale } = useParams();
  const { data, loading, error } = useSubscription(SUBSCRIPTION_SLO_DELETE_SESSION, {
    variables: { sub },
  });

  useEffect(() => {
    if (!sub || loading) {
      return;
    }

    if (error) {
      console.error('----- useSubscription(SUBSCRIPTION_SLO_DELETE_SESSION): ', error);
      return;
    }

    if (data?.onDeleteSession) {
      console.log('---- slo data: ', data);

      if (sub) {
        const ddLogPayload: DataDogCustomLog = {
          data: {
            affilateId: userData?.['custom:affiliate_id'],
            customerId: account?.accountId,
          },
        };

        logout()
          .then(() => deleteCognitoCookies())
          .then(() => {
            Object.keys(localStorage)
              .filter((key) => !key.startsWith('padi'))
              .map((key) => localStorage.removeItem(key));
          })
          .then(() => {
            datadogLogs.logger.info('SLO onDelete signal recieved. User logged out of store.', ddLogPayload);
          })
          .then(() => (pathname.endsWith('courses/') ? window.location.reload() : router.push(`/${locale}/courses`)));
      }
    }
  }, [account?.accountId, data, error, loading, locale, logout, pathname, router, sub, userData]);

  return <></>;
};

export default SloSubscribeOnDelete;
